// eslint-disable-next-line no-unused-vars
import React, { useEffect, useState } from 'react';

import useUser from 'Hooks/useUser';
import useFetch from 'Hooks/useFetch';
import BalanceDueModalComponent from 'Components/Header/BalanceDueModal';
import { API_OVERDUE, API_DUE_BALANCE } from 'Constants';

const DATE_TODAY = Date.now();

const BalanceDueModal = () => {
  const { data: user } = useUser();
  const fetcher = useFetch();

  const [open, setOpen] = useState(false);
  const [data, setData] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (user?.loggedIn) {
      fetcher(API_OVERDUE).then(res => {
        const overdueDate = new Date(res?.dueDate);
        const overdueDays = Math.floor((DATE_TODAY - overdueDate) / (24 * 3600 * 1000));
        setOpen(res?.showInfo);
        setData({ ...res, days: overdueDays });
      });
    }
  }, [user?.loggedIn]);

  const handleConfirm = async () => {
    setIsLoading(true);
    fetcher(API_DUE_BALANCE, {
      method: 'POST',
      body: JSON.stringify({ dueBalanceNotification: true }),
    }).finally(() => {
      setIsLoading(false);
      setOpen(false);
    });
  };

  return (
    <BalanceDueModalComponent
      open={ open }
      today={ new Date(DATE_TODAY).toISOString().split('T')[0].split('-').reverse().join('-') }
      data={ data }
      isLoading={ isLoading }
      onConfirm={ handleConfirm }
    />
  );
};

BalanceDueModal.displayName = 'BalanceDueModal';

export default BalanceDueModal;
